<div class="agenx-card-sub" [ngClass]="{'agenx-card-sub--orange': typeCard === 'orange'}">
  @if (modelCard === 'simple' || modelCard === 'done' ) {
  <h3 class="agenx-card-sub__h3 orange-title"> ${{ card_info.costs | number }} </h3>
  }
  <ul class="agenx-card-sub__items">
    @if (modelCard === 'simple' ) {
      <li class="agenx-card-sub__item">
        <p class="agenx-card-sub__item-text"> Categoría: </p>
        <p class="agenx-card-sub__item-text"> {{ card_info.residue?.category }} </p>
      </li>
      <li class="agenx-card-sub__item">
        <p class="agenx-card-sub__item-text"> Residuo: </p>
        <p class="agenx-card-sub__item-text"> {{ card_info.residue?.description }} </p>
      </li>
      <li class="agenx-card-sub__item">
        <p class="agenx-card-sub__item-text"> Precio: </p>
        <p class="agenx-card-sub__item-text"> ${{ card_info.residue?.price | number }} </p>
      </li>
      <li class="agenx-card-sub__item">
        <p class="agenx-card-sub__item-text"> Cantidad: </p>
        <p class="agenx-card-sub__item-text"> {{ card_info.amount }} </p>
      </li>
      @if (card_info.observations) {
        <li class="agenx-card-sub__item">
          <p class="agenx-card-sub__item-text"> Observación: </p>
          <p class="agenx-card-sub__item-text" [title]="card_info.observations!"> {{ card_info.observations! | limitChars: 35}} </p>
        </li>
      }
    } @else {
      @if (modelCard === 'done' ) {
      <li class="agenx-card-sub__item">
        <p class="agenx-card-sub__item-text"> Consecutivo: </p>
        <p class="agenx-card-sub__item-text"> {{ card_info.consecutive }} </p>
      </li>
      }
      @if (modelCard === 'pend' && card_info.date) {
      <li class="agenx-card-sub__item">
        <p class="agenx-card-sub__item-text bold">Fecha programado: </p>
        <p class="agenx-card-sub__item-text bold">{{ card_info.date }}</p>
      </li>
      }
      <li class="agenx-card-sub__item">
        <p class="agenx-card-sub__item-text"> {{ card_info.subscriber ? 'Niud:' : 'Identificación:' }} </p>
        <p class="agenx-card-sub__item-text"> {{ card_info.subscriber ? card_info.subscriber.niud : card_info.client?.identification }} </p>
      </li>
      <li class="agenx-card-sub__item">
        <p class="agenx-card-sub__item-text"> Nombre: </p>
        <p class="agenx-card-sub__item-text"> {{ card_info.subscriber ? card_info.subscriber.name  || '---': card_info.client?.name }} </p>
      </li>
      @if (card_info.client) {
      <li class="agenx-card-sub__item">
        <p class="agenx-card-sub__item-text">Código: </p>
        <p class="agenx-card-sub__item-text">{{ card_info.client.code || '---' }}</p>
      </li>
      } @else {
      <li class="agenx-card-sub__item">
        <p class="agenx-card-sub__item-text">Contrato: </p>
        <p class="agenx-card-sub__item-text">{{ card_info.subscriber?.contract || '---' }}</p>
      </li>
      }
      <li class="agenx-card-sub__item">
        <p class="agenx-card-sub__item-text"> Teléfono: </p>
        <p class="agenx-card-sub__item-text"> {{ card_info.subscriber ? card_info.subscriber.phone || '---' : card_info.client?.phone || '---' }} </p>
      </li>
      <li class="agenx-card-sub__item">
        <p class="agenx-card-sub__item-text"> Dirección: </p>
        <p class="agenx-card-sub__item-text"> {{ getAddress() | limitChars: 45 }} </p>
      </li>
      @if (modelCard === 'search' && unblock_date) {
      <li class="agenx-card-sub__alert agenx-mt--2 agenx-mb--1">
        <agenx-alert alertType="info"
          [alertText]="'El suscriptor podrá ser aforado nuevamente a partir del ' + unblock_date + '.'"></agenx-alert>
      </li>
      }
      @if (card_info.observations_ext) {
      <li class="agenx-card-sub__item">
        <p class="agenx-card-sub__item-text"> Observación: </p>
        <p class="agenx-card-sub__item-text" [title]="card_info.observations_ext!"> {{ card_info.observations_ext! | limitChars: 35}} </p>
      </li>
      }
    }
  </ul>
  <footer class="agenx-card-sub__footer">
    <div class="agenx-card-sub__footer-button">
      @if (modelCard === 'pend') {
        <agenx-button (click)="onCreateSpecial()" [typeButton]="typeCard" buttonText="Crear aforo"></agenx-button>
      } @else if (modelCard === 'search'){
        <agenx-button *ngIf="card_info.subscriber && !unblock_date" (click)="onCreateOrdinary()" [typeButton]="typeCard" buttonText="Crear aforo ordinario"></agenx-button>
        <agenx-button (click)="onCreateSpecial()" [typeButton]="typeCard" buttonText="Crear aforo especial"></agenx-button>
      } @else if (modelCard === 'done'){
        @if (card_info.state != 'Sin residuos') {
          <agenx-circle-button (click)="onDonwnload()"
            [buttonCircleSrc]="icon_download_src"
            [buttonCircleTitle]="'Descargar'"></agenx-circle-button>
          <agenx-circle-button (click)="onResend()"
            [buttonCircleSrc]="icon_resend_src"
            [buttonCircleTitle]="'Reenviar'"></agenx-circle-button>
        }
      } @else {
        <agenx-circle-button [typeButton]="'red'" (click)="clickOnCardsub('Delete')"
          [buttonCircleSrc]="icon_delete_src"
          [buttonCircleTitle]="'delete'"></agenx-circle-button>
        <agenx-circle-button (click)="clickOnCardsub('Edit')"
          [buttonCircleSrc]="icon_edit_src"
          [buttonCircleTitle]="'Edit'"></agenx-circle-button>
      }
    </div>

    <span class="agenx-card-sub__footer-line"></span>
  </footer>
</div>
